export default {
  computed: {
    toursQuickFilters() {
      return {
        title: 'Tours',
        filters: {
          columns: [
            {
              class: 'col-12 col-lg-2',
              filters: [
                {
                  name: 'status',
                  label: this.$gettext('Statuses'),
                  type: 'checkbox-group',
                  options: [
                    'DRAFT',
                    'READY',
                    'INTRANSIT',
                    'FINISHED',
                    'CANCELED'
                  ],
                  value: [],
                  stacked: true,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'status', 'in', val ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-5',
              filters: [
                {
                  name: 'tour-id',
                  label: this.$gettext('Tour ID'),
                  type: 'textarea',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      let ids
                      if (val.indexOf('\n') !== -1) {
                        ids = val.split('\n')
                        return [[ 'id', 'in', ids ]]
                      } else {
                        let ids = val.split(',')
                        return [[ 'id', 'in', ids ]]
                      }
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'tour-label',
                  label: this.$gettext('Tour Label'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'label', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'source-type',
                  label: this.$gettext('Tour Source'),
                  type: 'radio-group',
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: null
                    },
                    {
                      text: this.$gettext('Self Only'),
                      value: 1
                    },
                    {
                      text: this.$gettext('Shared Only'),
                      value: false
                    }
                  ],
                  value: null,
                  stacked: false,
                  callback: (val) => {
                    if (val === 1) {
                      return [[ 'ecosystem_id', 'eq', window.localStorage.getItem('eid') ]]
                    } else if (val === false) {
                      return [[ 'ecosystem_id', 'eq', window.localStorage.getItem('eid'), 'true' ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-5',
              filters: [
                {
                  name: 'tour-courier',
                  label: ' ',
                  type: 'user-autocomplete',
                  restrictToRoles: ['courier'],
                  placeholder: this.$gettext('Courier name or email'),
                  value: [],
                  callback: (val) => {
                    if (val.length > 0) {
                      let couriers = val.map(function (item) {
                        return item.id
                      })
                      return [[ 'courier_id', 'in', couriers ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  columns: [
                    {
                      class: 'col-12 col-lg-6',
                      filters: [
                        {
                          name: 'tour-created-at',
                          label: this.$gettext('Created At Date Range'),
                          type: 'daterange',
                          opens: 'left',
                          value: {
                            startDate: this.moment().toDate(),
                            endDate: this.moment().toDate(),
                            dateRangeActive: false
                          },
                          callback: (val) => {
                            if (val.dateRangeActive) {
                              const range = [
                                this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                                this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                              ]
                              return [[ 'created_at', 'bt', range ]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    },
                    {
                      class: 'col-12 col-lg-6',
                      filters: [
                        {
                          name: 'tour-updated-at',
                          label: this.$gettext('Updated At Date Range'),
                          type: 'daterange',
                          opens: 'left',
                          value: {
                            startDate: this.moment().tz(this.$tz).startOf('day').utc().subtract(14, 'days').toDate(),
                            endDate: this.moment().tz(this.$tz).endOf('day').utc().toDate(),
                            dateRangeActive: true
                          },
                          callback: (val) => {
                            if (val.dateRangeActive) {
                              const range = [
                                this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                                this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                              ]
                              return [[ 'updated_at', 'bt', range ]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    }
                  ]
                // },
                // {
                //   name: 'fixed-price-only',
                //   label: this.$gettext('Fixed Price Only'),
                //   type: 'checkbox',
                //   value: false,
                //   callback: (val) => {
                //     if (val) {
                //       return [[ 'fixed_amount_price_schedules.status', 'eq', 'canceled', 'true' ]]
                //     } else {
                //       return []
                //     }
                //   }
                },
                {
                  name: 'with-courier',
                  label: this.$gettext('Without courier assigned'),
                  type: 'checkbox',
                  value: false,
                  callback: (val) => {
                    if (val) {
                      return [['courier_id', 'eq', null]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
